(function () {
  function getCardImages(swatch) {
    const card = swatch.closest('.card-wrapper');
    if (!card) return null;
    const media = card.querySelector('.card__media .media');
    if (!media) return null;
    const img = media.querySelector('img');
    if (!img) return null;
    const secondaryImg = img.nextElementSibling && img.nextElementSibling.tagName === 'IMG' ? img.nextElementSibling : null;
    return { img, secondaryImg };
  }

  function onEnter(event) {
    const swatch = event.target.closest('.card__variant-swatch[data-variant-image]');
    if (!swatch) return;
    const images = getCardImages(swatch);
    if (!images) return;
    const { img, secondaryImg } = images;

    if (!img.dataset.originalSrc) {
      img.dataset.originalSrc = img.currentSrc || img.src;
      img.dataset.originalSrcset = img.getAttribute('srcset') || '';
    }

    img.removeAttribute('srcset');
    img.src = swatch.getAttribute('data-variant-image');

    // Force the primary image visible in case the theme's built-in
    // "secondary image on hover" effect would otherwise cover it up.
    img.style.opacity = '1';
    img.style.transform = 'none';
    if (secondaryImg) secondaryImg.style.opacity = '0';
  }

  function onLeave(event) {
    const swatch = event.target.closest('.card__variant-swatch[data-variant-image]');
    if (!swatch) return;
    const images = getCardImages(swatch);
    if (!images) return;
    const { img, secondaryImg } = images;
    if (!img.dataset.originalSrc) return;

    img.src = img.dataset.originalSrc;
    if (img.dataset.originalSrcset) img.setAttribute('srcset', img.dataset.originalSrcset);

    img.style.opacity = '';
    img.style.transform = '';
    if (secondaryImg) secondaryImg.style.opacity = '';
  }

  document.addEventListener('mouseover', onEnter);
  document.addEventListener('mouseout', onLeave);
  document.addEventListener('focusin', onEnter);
  document.addEventListener('focusout', onLeave);
})();
